"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PriceOffComboSavingsVariantOne = exports.PriceOffComboSavingsStyle = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _Price = _interopRequireDefault(require("@airasia/phoenix-components/components/Price"));
var _Popover = _interopRequireDefault(require("@airasia/phoenix-components/components/Popover"));
var _HotelCard = require("./HotelCard.proptypes");
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));
var _PriceBreakDown = _interopRequireDefault(require("@airasia/phoenix-components/components/PriceBreakDown"));
var _ShimmerButton = _interopRequireDefault(require("@airasia/phoenix-components/components/ShimmerButton"));
var _PriceBreakDownPopOver = _interopRequireDefault(require("@airasia/phoenix-components/components/PriceBreakDownPopOver"));
var _BogoFomoLabel = _interopRequireDefault(require("./BogoFomo/BogoFomoLabel"));
var _BogoInfoIcon = _interopRequireDefault(require("./BogoInfoIcon"));
var _constants = require("../NewRoomCard/constants");
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceWrapper",
  componentId: "sc-1hc0pvu-0"
})(["height:", ";display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end;margin-left:auto;padding-right:", ";padding-bottom:", ";padding-top:", ";font-style:normal;font-weight:normal;font-size:", ";line-height:150%;", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '100%' : '60%';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.small;
}, function (_ref3) {
  var theme = _ref3.theme,
    isMobile = _ref3.isMobile;
  return !isMobile ? theme.space.small : 0;
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
    theme = _ref4.theme;
  return !isMobile && theme.space.standard;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.XSmall;
}, function (_ref6) {
  var isHotelCrossSellCard = _ref6.isHotelCrossSellCard;
  return isHotelCrossSellCard ? 'width: 35%;' : '';
});
var PriceText = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceText",
  componentId: "sc-1hc0pvu-1"
})(["font-style:normal;font-weight:normal;font-size:", ";line-height:150%;text-align:right;color:#75767a;mix-blend-mode:normal;padding-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.tiny;
});
var StrikeThrough = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__StrikeThrough",
  componentId: "sc-1hc0pvu-2"
})(["font-style:normal;font-weight:normal;font-size:", ";line-height:", ";text-decoration-line:line-through;color:#75767a;mix-blend-mode:normal;padding-right:", ";margin-top:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize.XSmall;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.normal;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.micro;
}, function (_ref12) {
  var combo = _ref12.combo;
  return combo ? '6px' : '';
});
var GuestInfo = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__GuestInfo",
  componentId: "sc-1hc0pvu-3"
})(["font-style:normal;font-weight:500;font-size:10px;line-height:", ";text-align:right;color:#212124;mix-blend-mode:normal;"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.lineHeight.XSmall;
});
var Includes = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__Includes",
  componentId: "sc-1hc0pvu-4"
})(["font-style:normal;font-weight:normal;font-size:10px;line-height:150%;text-align:right;color:#75767a;mix-blend-mode:normal;padding-bottom:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.tiny;
});
var Total = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__Total",
  componentId: "sc-1hc0pvu-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:", ";display:flex;align-items:center;text-align:right;color:#4c4c50;mix-blend-mode:normal;"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.lineHeight.XSmall;
});
var BoldWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__BoldWrapper",
  componentId: "sc-1hc0pvu-6"
})(["padding-left:5px;font-weight:bold;"]);
var ComboSavingsBubblePrice = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ComboSavingsBubblePrice",
  componentId: "sc-1hc0pvu-7"
})(["background-color:#067e41;margin-left:45%;margin-top:5px;display:flex;flex-direction:column;align-items:center;justify-content:center;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-left-radius:4px;min-width:60%;white-space:nowrap;padding:5px 10px 5px 10px;color:white;margin-bottom:10px;position:relative;"]);
var ComboSavingsTagBubbleRightArrow = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ComboSavingsTagBubbleRightArrow",
  componentId: "sc-1hc0pvu-8"
})(["position:absolute;bottom:-5px;right:0px;width:0px;height:0px;background-color:transparent;border-style:solid;border-top-width:0px;border-right-width:15px;border-bottom-width:15px;border-left-width:10px;border-top-color:transparent;border-right-color:#067e41;border-bottom-color:transparent;border-left-color:transparent;"]);
var PriceOffComboSavingsStyle = _styledComponents.default.p.withConfig({
  displayName: "PriceInfo__PriceOffComboSavingsStyle",
  componentId: "sc-1hc0pvu-9"
})(["color:white;text-transform:capitalize;text-align:center;padding:0px;margin:2px;font-size:12px;line-height:18px;"]);
exports.PriceOffComboSavingsStyle = PriceOffComboSavingsStyle;
var PriceOffComboSavingsVariantOne = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceOffComboSavingsVariantOne",
  componentId: "sc-1hc0pvu-10"
})(["text-align:center;font-weight:900;"]);
exports.PriceOffComboSavingsVariantOne = PriceOffComboSavingsVariantOne;
var SelectRoomButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__SelectRoomButtonContainer",
  componentId: "sc-1hc0pvu-11"
})(["margin-top:10px;"]);
var PromoContainer = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PromoContainer",
  componentId: "sc-1hc0pvu-12"
})(["display:flex;background-color:#ad1c29 !important;border-radius:4px;padding-top:4px;padding-bottom:4px;padding-left:1px !important;padding-right:5px !important;align-items:center;justify-content:center;color:white;position:relative;top:-3px;"]);
var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ToolTipContent",
  componentId: "sc-1hc0pvu-13"
})(["display:flex;flex-flow:column wrap;"]);
var DiscountWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__DiscountWrapper",
  componentId: "sc-1hc0pvu-14"
})(["display:flex;flex-direction:'row';"]);
var SnapSavingsComponent = function SnapSavingsComponent(_ref16) {
  var gaIdExperimentValue = _ref16.gaIdExperimentValue,
    isComboSavingsTagEnabled = _ref16.isComboSavingsTagEnabled,
    discountText = _ref16.discountText,
    priceCurrency = _ref16.priceCurrency,
    locale = _ref16.locale,
    savingsAmount = _ref16.savingsAmount;
  var fixedFontSizeForVariant2 = '10px';
  if (discountText) {
    if (isComboSavingsTagEnabled && savingsAmount) {
      var snapSavings = Math.abs(savingsAmount);
      if (gaIdExperimentValue === 1) {
        return /*#__PURE__*/_react.default.createElement(ComboSavingsBubblePrice, null, /*#__PURE__*/_react.default.createElement(PriceOffComboSavingsStyle, null, discountText), /*#__PURE__*/_react.default.createElement(_Price.default, {
          amount: snapSavings,
          currency: priceCurrency,
          allowLocaleFormat: true,
          locale: locale,
          priceTemplate: "TEMPLATE2",
          color: "white",
          noDecimalValues: true,
          defaultIDRLocale: false
        }), /*#__PURE__*/_react.default.createElement(ComboSavingsTagBubbleRightArrow, null));
      }
      return /*#__PURE__*/_react.default.createElement(_Label.default, {
        textLimit: 4,
        customProperties: {
          size: fixedFontSizeForVariant2
        },
        labelColor: "tertiaryLight",
        textColor: "tertiaryDark"
      }, /*#__PURE__*/_react.default.createElement(PriceOffComboSavingsVariantOne, null, discountText, ' ', /*#__PURE__*/_react.default.createElement(_Price.default, {
        amount: snapSavings,
        currency: priceCurrency,
        allowLocaleFormat: true,
        locale: locale,
        priceTemplate: "TEMPLATE3",
        color: "white",
        noDecimalValues: true,
        defaultIDRLocale: false,
        customProperties: {
          fontSize: fixedFontSizeForVariant2
        }
      })));
    }
    return /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: "tertiaryLight",
      textColor: "tertiaryDark"
    }, discountText);
  }
  return null;
};
SnapSavingsComponent.propTypes = _HotelCard.PriceInfoPropTypes;
SnapSavingsComponent.defaultProps = _HotelCard.PriceInfoDefaultProps;
var PriceInfo = function PriceInfo(_ref17) {
  var discountText = _ref17.discountText,
    strikeThrough = _ref17.strikeThrough,
    price = _ref17.price,
    priceText = _ref17.priceText,
    perGuestText = _ref17.perGuestText,
    snapPriceText = _ref17.snapPriceText,
    totalPrice = _ref17.totalPrice,
    isMobile = _ref17.isMobile,
    theme = _ref17.theme,
    locale = _ref17.locale,
    gaIdExperimentValue = _ref17.gaIdExperimentValue,
    isComboSavingsTagEnabled = _ref17.isComboSavingsTagEnabled,
    savingsAmount = _ref17.savingsAmount,
    selectRoomLabel = _ref17.selectRoomLabel,
    withSelectRoom = _ref17.withSelectRoom,
    isBogoPromoEnabled = _ref17.isBogoPromoEnabled,
    BogoTag = _ref17.BogoTag,
    move = _ref17.move,
    accessible = _ref17.accessible,
    isRM9PromoEnabled = _ref17.isRM9PromoEnabled,
    pricebreakdownData = _ref17.pricebreakdownData,
    handleMouseEnter = _ref17.handleMouseEnter,
    handleMouseLeave = _ref17.handleMouseLeave,
    isHotel = _ref17.isHotel,
    comboSavingsData = _ref17.comboSavingsData,
    isComboSavingsPopUpEnabled = _ref17.isComboSavingsPopUpEnabled,
    snapSummaryMultipax = _ref17.snapSummaryMultipax,
    baseRate = _ref17.baseRate,
    isHotelCrossSellCard = _ref17.isHotelCrossSellCard,
    isMapView = _ref17.isMapView;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _ref18 = strikeThrough || {},
    currency = _ref18.currency,
    value = _ref18.value;
  var priceCurrency = price.currency;
  var priceValue = price.value;
  var totalPriceCurrency = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.currency;
  var totalPriceValue = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.value;
  var totalPriceText = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.text;
  var comboSavingPrice = comboSavingsData !== null && comboSavingsData !== void 0 && comboSavingsData.bundleSavingPrice ? "".concat(priceCurrency, " ").concat(comboSavingsData === null || comboSavingsData === void 0 ? void 0 : comboSavingsData.bundleSavingPrice) : '';
  var baseRateValue = baseRate === null || baseRate === void 0 ? void 0 : baseRate.value;
  var handleMouseLeaveCalled = function handleMouseLeaveCalled(e) {
    e.preventDefault();
    handleMouseLeave();
  };
  var getToolTipContent = function getToolTipContent() {
    return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(_PriceBreakDown.default, (0, _extends2.default)({}, pricebreakdownData, {
      theme: theme
    })));
  };
  var getPopOver = function getPopOver() {
    return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(_PriceBreakDownPopOver.default, (0, _extends2.default)({}, comboSavingsData, {
      theme: theme
    })));
  };
  var _useState = (0, _react.useState)(_constants.CONTENT_POSITION.CUSTOM),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var triggerRef = (0, _react.useRef)(null);
  var handleMouseEnterCalled = function handleMouseEnterCalled() {
    handleMouseEnter();
  };
  var checkSpaceAndSetPosition = function checkSpaceAndSetPosition() {
    var popoverHeight = 425;
    var triggerElement = triggerRef.current;
    if (triggerElement) {
      var rect = triggerElement.getBoundingClientRect();
      if (rect.top >= popoverHeight) {
        setPosition(_constants.CONTENT_POSITION.CUSTOM);
      } else if (window.innerHeight - rect.bottom >= popoverHeight) {
        setPosition(_constants.CONTENT_POSITION.BOTTOM);
      } else {
        setPosition(_constants.CONTENT_POSITION.BOTTOM);
      }
    } else {
      setPosition(_constants.CONTENT_POSITION.BOTTOM);
    }
  };
  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      checkSpaceAndSetPosition();
    };
    window.addEventListener('scroll', handleScroll);
    checkSpaceAndSetPosition();
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  var positionBottom = position === _constants.CONTENT_POSITION.BOTTOM;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PriceWrapper, {
      isMobile: isMobile,
      isHotelCrossSellCard: isHotelCrossSellCard
    }, isBogoPromoEnabled && BogoTag && !isMobile && (!isRM9PromoEnabled ? /*#__PURE__*/_react.default.createElement(_BogoFomoLabel.default, {
      BogoTag: BogoTag
    }) : /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: theme,
      accessible: accessible,
      asToolTip: true,
      content: getToolTipContent(),
      position: position,
      trigger: isMobile ? _constants.TRIGGERS.click : _constants.TRIGGERS.hover,
      width: 360,
      customProperties: {
        position: 'absolute',
        left: "100%",
        height: "16px"
      },
      popBottomLeft: positionBottom ? '-194px' : undefined,
      bottomTipLeft: positionBottom ? '90%' : undefined,
      bottomTransform: positionBottom ? '36px' : undefined,
      zIndex: 1
    }, /*#__PURE__*/_react.default.createElement(PromoContainer, {
      ref: triggerRef,
      onMouseEnter: handleMouseEnterCalled,
      onMouseLeave: handleMouseLeaveCalled
    }, /*#__PURE__*/_react.default.createElement(_Label.default, null, BogoTag), /*#__PURE__*/_react.default.createElement(_BogoInfoIcon.default, null)))), isHotel && /*#__PURE__*/_react.default.createElement(DiscountWrapper, {
      isMobile: isMobile
    }, currency && value && /*#__PURE__*/_react.default.createElement(StrikeThrough, null, "".concat(currency, " ").concat(value)), /*#__PURE__*/_react.default.createElement(SnapSavingsComponent, {
      discountText: discountText,
      savingsAmount: savingsAmount,
      locale: locale,
      priceCurrency: priceCurrency,
      gaIdExperimentValue: gaIdExperimentValue,
      isComboSavingsTagEnabled: isComboSavingsTagEnabled
    })), !isHotel && !isBogoPromoEnabled && !isComboSavingsPopUpEnabled && /*#__PURE__*/_react.default.createElement(SnapSavingsComponent, {
      discountText: discountText,
      savingsAmount: savingsAmount,
      gaIdExperimentValue: gaIdExperimentValue,
      locale: locale,
      priceCurrency: priceCurrency,
      isComboSavingsTagEnabled: isComboSavingsTagEnabled
    }), isComboSavingsPopUpEnabled && comboSavingPrice && discountText && /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: "AIRASIA_MOVE",
      accessible: accessible,
      asToolTip: true,
      content: getPopOver(),
      position: isMapView ? _constants.CONTENT_POSITION.CUSTOM : position,
      trigger: isMobile ? _constants.TRIGGERS.click : _constants.TRIGGERS.hover,
      width: 360.5,
      customProperties: {
        position: 'absolute',
        left: '100%',
        height: "12px"
      },
      popBottomLeft: positionBottom && !isMapView ? '-194px' : undefined,
      bottomTransform: positionBottom && !isMapView ? '60px' : undefined,
      bottomTipLeft: positionBottom && !isMapView ? '90%' : undefined,
      zIndex: 1
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: triggerRef
    }, /*#__PURE__*/_react.default.createElement(_ShimmerButton.default, {
      width: _constant.WIDTH,
      height: _constant.HEIGHT,
      buttonTextTop: discountText,
      buttonTextBottom: comboSavingPrice,
      theme: theme,
      buttonColor: "#157B3E",
      shimmerColor: "#59E659",
      isShowIcon: true,
      handleMouseEnter: handleMouseEnterCalled,
      handleMouseLeave: handleMouseLeaveCalled
    }))), !isHotel && currency && value && /*#__PURE__*/_react.default.createElement(StrikeThrough, {
      combo: isComboSavingsPopUpEnabled
    }, "".concat(currency, " ").concat(value)), !isComboSavingsPopUpEnabled && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Price.default, {
      amount: priceValue,
      currency: priceCurrency,
      allowLocaleFormat: true,
      locale: locale,
      noDecimalValues: true,
      defaultIDRLocale: false,
      customProperties: {
        marginRight: '-8px'
      }
    }), priceText && /*#__PURE__*/_react.default.createElement(PriceText, null, priceText), perGuestText && /*#__PURE__*/_react.default.createElement(GuestInfo, null, perGuestText), snapPriceText && /*#__PURE__*/_react.default.createElement(Includes, null, snapPriceText), totalPrice && /*#__PURE__*/_react.default.createElement(Total, null, "".concat(totalPriceCurrency), /*#__PURE__*/_react.default.createElement(BoldWrapper, null, "".concat(totalPriceValue, " ").concat(totalPriceText)))), isComboSavingsPopUpEnabled && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Price.default, {
      amount: baseRateValue,
      currency: priceCurrency,
      allowLocaleFormat: true,
      locale: locale,
      noDecimalValues: true,
      defaultIDRLocale: false,
      customProperties: {
        marginRight: '-8px'
      }
    }), snapSummaryMultipax && /*#__PURE__*/_react.default.createElement(Includes, null, snapSummaryMultipax)), withSelectRoom && /*#__PURE__*/_react.default.createElement(SelectRoomButtonContainer, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      paddingRight: "24px",
      paddingLeft: "24px",
      backgroundColor: move ? '#0CE865' : 'primary',
      color: move ? '#023C40' : 'primaryLight',
      borderRadius: move && '32px',
      padding: move && '12px,24px,12px,24px',
      borderColor: move && '#023C40',
      fontWeight: move && 'medium'
    }, selectRoomLabel)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
PriceInfo.propTypes = _HotelCard.PriceInfoPropTypes;
PriceInfo.defaultProps = _HotelCard.PriceInfoDefaultProps;
var _default = PriceInfo;
exports.default = _default;